import React from "react";
import { Box, Button, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";

export default function PipePanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [
      // { c: "*" }
    ],
    columns: [
      {
        accessorKey: "c",
        header: "c",
        size: 10,
      },
      {
        accessorKey: "Spec",
        header: "Spec",
        size: 10,
      },
      {
        accessorKey: "Component",
        header: "Component",
        size: 10,
      },
      {
        accessorKey: "Size",
        header: "Size",
        size: 10,
      },
      {
        accessorKey: "Schedule",
        header: "Schedule",
        size: 10,
      },
      {
        accessorKey: "Type",
        header: "Type",
        size: 10,
      },
      {
        accessorKey: "Dimension Standard",
        header: "Dimension Standard",
        size: 10,
      },
      {
        accessorKey: "Material",
        header: "Material",
        size: 10,
      },
      {
        accessorKey: "Requirements",
        header: "Requirements",
        size: 10,
      },
      {
        accessorKey: "Material Description",
        header: "Material Description",
        size: 10,
      },
      {
        accessorKey: "Material Code",
        header: "Material Code",
        size: 10,
      },
      {
        accessorKey: "Family Table",
        header: "Family Table",
        size: 10,
      },
    ],
  });

  const table2 = useMaterialReactTable({
    ...lightTable,
    data: [],
    columns: [
      {
        accessorKey: "c",
        header: "",
        size: 10,
      },
      {
        accessorKey: "Dist. From D.L.",
        header: "Dist. From D.L.",
        size: 60,
      },
      {
        accessorKey: "Orientation",
        header: "Orientation",
        size: 60,
      },
      {
        accessorKey: "Dist. From C.L. (+/-)",
        header: "Dist. From D.L.",
        size: 60,
      },
      {
        accessorKey: "Direction",
        header: "Direction",
        size: 60,
      },
      {
        accessorKey: "Location",
        header: "Location",
        size: 60,
      },
      {
        accessorKey: "Nozzle Material",
        header: "Nozzle Material",
        size: 60,
      },
    ],
  });
  return (
    <>
      <Grid container>
        <Grid item xs={8} sx={{ pt: 2 }}>
          <InputGroupShape name="Nozzles Details">
            <MaterialReactTable table={table} />
          </InputGroupShape>
        </Grid>

        {/* <Grid item xs={4} sx={{ pt: 2 }}>
          <InputGroupShape name="Nozzles Details">
            <MaterialReactTable table={table2} />
          </InputGroupShape>
        </Grid> */}
      </Grid>

      <Box sx={{ p: 1 }}>
        <Button sx={{ mr: 1 }} variant="contained">
          Obtain
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Family
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Part
        </Button>
      </Box>
    </>
  );
}
